import { Box, Paper, Slide, Stack } from "@mui/material"
import InputField1 from "../../../../../components/ui/InputField1"

function SupportFor({ supportFor }) {

  return (
    <Slide direction="left" in={true} timeout={500}>
      <Paper
        sx={{
          p: 3,
          mt: 3,
          borderRadius: "6px",
          boxShadow: "0 0 20px 0 #00000020"
        }}
      >
        <Stack
          spacing={3}
          sx={{
            label: {
              fontSize: "18px",
              fontWeight: "500",
              whiteSpace: "normal"
            }
          }}
        >
          {supportFor === "else" &&
            <Box>
              <InputField1
                placeholder="Enter text"
                name="relationshipToPerson"
                label="What's your relationship to the person?"
              />
            </Box>
          }
          <Box>
            <InputField1
              type="textarea"
              placeholder="Enter text"
              name="currentChallengeArea"
              label="What area of life is most challenging right now?"
            />
          </Box>
          <Box>
            <InputField1
              type="textarea"
              placeholder="Enter text"
              name="supportTypePreference"
              label="What type of support feels right for you (or them)?"
            />
          </Box>
        </Stack>
      </Paper>
    </Slide>
  )
}

export default SupportFor